import React, { useState } from 'react';
import CollapsibleChevronBlock from '~/components/molecule/CollapsibleChevronBlock';
import { Body, Heading4 } from '~/components/atom/Typography';

export type Props = {
  dataTestId?: string;
};

const WarningMessage: React.FCC<Props> = ({}) => {
  const [open, setOpen] = useState(true);

  return (
    <CollapsibleChevronBlock
      header={<Heading4 color={{ group: 'danger' }}>Read this!</Heading4>}
      isOpen={open}
      variant="danger"
      onToggle={() => setOpen(prev => !prev)}
    >
      <div>
        <Body color={{ group: 'danger' }}>
          This feature allows us to adjust the HTML directly.&nbsp;
          <b>BE VERY CAREFUL WHEN YOU ARE MAKING CHANGES</b>. If you miss a
          colon or semi-colon everything could get broken.&nbsp;
          <b>Get help from a developer in most cases.</b>
        </Body>
        <Body color={{ group: 'danger' }}>
          Before you start,&nbsp;
          <b>make sure that the editor is in a stable state</b>. All the images
          must be saved and there must be no errors in the editor.{' '}
          <u>
            If you are in a flow, save the flow changes first. After that make
            direct changes to the HTML.
          </u>
          .
        </Body>
        <Body size="base">
          Also note that inserting this HTML adds additional whitespace at the
          top and the bottom of the editor. Ensure that you remove them before
          you save the changes in the editor.
        </Body>
      </div>
    </CollapsibleChevronBlock>
  );
};

export default WarningMessage;
